import { DetailInfoProps } from 'utils/ts/interfaces';

import { DetailInfoItem } from 'components/DetailInfoItem/DetailInfoItem';
import { personalInfoStyles } from './styles';

import { FileDownloadItem } from 'components/FileDownloadItem';

const { Block, Container, Contacts, Text, Empty, FileList, Title, Link } =
  personalInfoStyles;

interface PersonalInfoProps extends DetailInfoProps {
  isManager: boolean;
}

export const PersonalInfo = ({
  status,
  fullName,
  phoneNumber,
  companyName,
  email,
  uin,
  client,
  agent,
  comment,
  payment,
  paymentSchedule,
  isManager,
  files,
}: PersonalInfoProps) => {
  const paymentStatus = payment?.status ? payment.status : null;
  const agentInfo = agent && agent.numberType ? agent.numberType : null;
  const numberType = client && client.numberType ? client.numberType : agentInfo;

  const isEdit =
    ((status === 'Выдано' && agent !== null && paymentStatus !== 'Выплачено') ||
      (status !== 'Отложил покупку' &&
        status !== 'Новая' &&
        status !== 'Выдано' &&
        status !== 'Отказ клиента')) &&
    isManager;

  return (
    <Container>
      <Contacts>
        <DetailInfoItem edit={isEdit} name="Имя" fieldName="fullName" value={fullName} />
        {(email || isEdit) && (
          <DetailInfoItem
            edit={isEdit}
            name="Почта"
            fieldName="email"
            inputType="email"
            value={email ? email : ''}
          />
        )}
        {(phoneNumber || isEdit) && (
          <DetailInfoItem
            edit={isEdit}
            name="Телефон"
            fieldName="phoneNumber"
            inputType="tel"
            mask="+7 999 999 99 99"
            value={phoneNumber}
          />
        )}
        {(uin || isEdit) && (
          <DetailInfoItem edit={isEdit} name="ИНН" fieldName="uin" value={uin} />
        )}
        {(companyName || isEdit) && (
          <DetailInfoItem
            edit={isEdit}
            name="Компания"
            fieldName="companyName"
            value={companyName}
          />
        )}
        {numberType && (
          <DetailInfoItem
            edit={false}
            name="Удобный вариант связи"
            fieldName="numberType"
            value={numberType}
          />
        )}
      </Contacts>
      <Block>
        <span>Комментарий</span>
        {comment ? <Text>{comment}</Text> : null}
      </Block>
      <Block>
        <span>Файлы</span>
        {files.length > 0 ? (
          <FileList>
            {files.map(({ id, name, url, size }) => (
              <FileDownloadItem key={id} name={name} id={id} url={url} size={size} />
            ))}
          </FileList>
        ) : (
          <Empty>Значения отсутствуют</Empty>
        )}
      </Block>
      <Block>
        <span>График платежей</span>

        {paymentSchedule && paymentSchedule.length > 0 ? (
          <FileList>
            {paymentSchedule.map(item => (
              <Link href={item} target="_blank" rel="noopener noreferrer" key={item}>
                <Title>{item}</Title>
              </Link>
            ))}
          </FileList>
        ) : (
          <Text>—</Text>
        )}
      </Block>
    </Container>
  );
};
